export const formatCancellationPoliciesOptions = cPolicies => {
  return cPolicies.map(cp => ({ value: cp?.id, label: cp?.title }));
};
